(function () {
  "use strict";
  if (window.LollensteinChargenpassMobileInit) return;
  window.LollensteinChargenpassMobileInit = true;

  /* Lollenstein Produktseiten-Erweiterung (23.08.2026, v10)
     - Mobile-Verdichtung Chargenpass + Lieferform-Auswahl als Liste
     - Kaufbereich oben nur Bestellablauf; der Artikeltext steht unten im
       Chargenpass (Story-oben deaktiviert, Funktionen fuer Rueckbau vorhanden)
     - Charge-Box im Kaufbereich ausgeblendet
     - Grundpreis in der Auswahl-Box (PAngV)
     - Lieferzeit-Widget (delm) wird in die Auswahl-Box verschoben
     - Chargenpass-Titel nach Produktart ("dieses Heu" / "diese Heulage" / "dieses Stroh")
     - Desktop: Lieferform-Kacheln ohne Grundpreis-Doppelung, ohne Erklärsatz
     Eigenständige Erweiterung: Original-CSS/-JS bleiben unverändert.
     Entfernen = Script-Einbindung in sections/lollenstein-chargenpass.liquid löschen. */

  var CSS = [
    ".ls-cp__body-more > .ls-cp__body-more-summary,",
    ".ls-cp__fit-details > .ls-cp__fit-details-summary {",
    "  color: var(--ls-cp-brand-dark, #006b91);",
    "  cursor: pointer;",
    "  font-size: 0.85rem;",
    "  font-weight: 700;",
    "  list-style: none;",
    "  padding: 0.35rem 0;",
    "}",
    ".ls-cp__body-more-summary::-webkit-details-marker,",
    ".ls-cp__fit-details-summary::-webkit-details-marker { display: none; }",
    ".ls-cp__body-more-summary::after,",
    ".ls-cp__fit-details-summary::after { content: ' +'; font-weight: 400; }",
    ".ls-cp__body-more[open] > .ls-cp__body-more-summary::after,",
    ".ls-cp__fit-details[open] > .ls-cp__fit-details-summary::after { content: ' \\2212'; }",
    ".ls-cp__fit-details { border-top: 1px solid var(--ls-cp-line, #dedede); margin-top: 0.15rem; }",
    ".ls-cp__fit-details .ls-cp__fit-note { border-top: 0; padding-top: 0.2rem; }",
    ".ls-qm-quantity-summary__baseprice { margin: 1px 0 0; color: #53636d; font-size: 0.75rem; }",
    "/* Lieferzeit-Widget (delm) als letzte Zeile der Auswahl-Box */",
    ".ls-qm-delivery-note { margin-top: 10px; padding-top: 10px; border-top: 1px solid rgba(0, 107, 145, 0.14); }",
    "/* Eignungskarten: Grid-Zeilen nicht auf Kartenhoehe strecken, Badge kompakt halten */",
    ".ls-cp__fit-card { align-content: start; }",
    ".ls-cp__fit-rating { align-self: start; }",
    "/* Desktop: Lieferform-Bereich entschlacken (Grundpreise stehen in der Auswahl-Box) */",
    "@media (min-width: 750px) {",
    "  .ls-qm-choice-heading p { display: none; }",
    "  .ls-qm-variant-card__unit-prices { display: none; }",
    "}",
    "/* Charge-Box im Kaufbereich komplett ausgeblendet (Chargendetails stehen im Chargenpass) */",
    ".ls-qm-charge-summary { display: none; }",
    "/* Produkttext oben im Kaufbereich - exakt die Chargenpass-Optik (Original-Klassen + Farbvariablen) */",
    ".ls-qm-product-story { --ls-cp-ink: #151515; --ls-cp-muted: #5f5f5f; --ls-cp-line: #dedede; --ls-cp-soft: #f4f2ec; --ls-cp-brand: #00a5df; --ls-cp-brand-light: #4eb1e5; --ls-cp-brand-dark: #006b91; --ls-cp-brand-soft: #e8f7fc; --ls-cp-table-stripe: #f3fafd; --ls-cp-radius: 18px; color: var(--ls-cp-ink); margin: 14px 0 2px; }",
    ".ls-qm-product-story > .ls-cp__lead:first-child { margin-top: 0; }",
    ".ls-qm-product-story .ls-cp__body-more { margin-top: 4px; }",
    "@media (max-width: 749px) {",
    "  .ls-cp { margin-block: 1.4rem; }",
    "  .ls-cp__shell { padding-inline: 0.9rem; }",
    "  .ls-cp__header { margin-bottom: 1.1rem; }",
    "  .ls-cp__heading { font-size: 1.5rem; }",
    "  .ls-cp__intro { font-size: 0.95rem; margin-top: 0.6rem; }",
    "  .ls-cp__content > * + * { margin-top: 0.7rem; }",
    "  .ls-cp__section { border-radius: 14px; padding: 0.95rem; }",
    "  .ls-cp__section-title { font-size: 1.12rem; margin-bottom: 0.7rem; }",
    "  .ls-cp__subheading { font-size: 0.98rem; margin-top: 0.9rem; }",
    "  .ls-cp__lead { font-size: 1rem; }",
    "  .ls-cp__body { font-size: 0.94rem; }",
    "  .ls-cp__selling-points { gap: 0.4rem; margin: 0.75rem 0; }",
    "  .ls-cp__selling-point { border-radius: 8px; font-size: 0.92rem; line-height: 1.4; padding: 0.55rem 0.65rem; }",
    "  .ls-cp__status { border-radius: 14px; min-height: 68px; padding: 0.9rem; }",
    "  .ls-cp__fit-card, .ls-cp__composition-item, .ls-cp__disclosure .ls-cp__analysis,",
    "  .ls-cp__quality-promise, .ls-cp__plant-fact, .ls-cp__trait,",
    "  .ls-cp__classification-card, .ls-cp__classification-fact { box-shadow: none; }",
    "  .ls-cp__trait-grid { display: block; }",
    "  .ls-cp__trait { align-items: baseline; background: transparent; border: 0; border-bottom: 1px solid var(--ls-cp-line, #dedede); border-radius: 0; display: flex; gap: 0.7rem; justify-content: space-between; padding: 0.5rem 0.1rem; }",
    "  .ls-cp__trait:last-child { border-bottom: 0; }",
    "  .ls-cp__trait-label { flex: 0 0 auto; font-size: 0.82rem; }",
    "  .ls-cp__trait-value { text-align: right; }",
    "  .ls-cp__trait-source { font-size: 0.78rem; }",
    "  .ls-cp__fit-grid { gap: 0.6rem; margin-top: 0.85rem; }",
    "  .ls-cp__fit-card { border-radius: 12px; gap: 0.5rem; padding: 0.8rem 0.85rem; }",
    "  .ls-cp__fit-card-head { gap: 0.6rem; }",
    "  .ls-cp__fit-icon { flex-basis: 1.5rem; font-size: 0.8rem; height: 1.5rem; }",
    "  .ls-cp__fit-card .ls-cp__card-title { font-size: 0.95rem; }",
    "  .ls-cp__fit-area { font-size: 0.64rem; margin-bottom: 0.15rem; }",
    "  .ls-cp__fit-rating { font-size: 0.76rem; padding: 0.3rem 0.6rem; }",
    "  .ls-cp__fit-reason { font-size: 0.88rem; }",
    "  .ls-cp__fit-note { font-size: 0.8rem; padding-top: 0.5rem; }",
    "  .ls-cp__fit-intro { font-size: 0.9rem; }",
    "  .ls-cp__fit-footnote { font-size: 0.76rem; }",
    "  .ls-cp__fit-more-summary { padding: 0.75rem 0.85rem; }",
    "  .ls-cp__fit-list { gap: 0.5rem; padding: 0.7rem; }",
    "  .ls-cp__fit-row { padding: 0.7rem 0.75rem; }",
    "  .ls-cp__fit-row-title { font-size: 0.92rem; }",
    "  .ls-cp__key-metrics { gap: 0.45rem; }",
    "  .ls-cp__key-metric { border-radius: 9px; padding: 0.6rem 0.65rem; }",
    "  .ls-cp__key-metric-value { font-size: 0.98rem; }",
    "  .ls-cp__classification-grid, .ls-cp__classification-facts { gap: 0.5rem; }",
    "  .ls-cp__classification-card, .ls-cp__classification-fact { border-radius: 10px; padding: 0.7rem; }",
    "  .ls-cp__plant-facts { gap: 0.5rem; }",
    "  .ls-cp__plant-fact { border-radius: 10px; padding: 0.7rem; }",
    "  .ls-cp__composition { gap: 0.55rem; }",
    "  .ls-cp__composition-item { border-radius: 10px; gap: 0.45rem 0.7rem; padding: 0.8rem; }",
    "  .ls-cp__disclosure { border-radius: 14px; }",
    "  .ls-cp__disclosure-summary { gap: 0.75rem; min-height: 52px; padding: 0.8rem 1rem; }",
    "  .ls-cp__disclosure-body { padding: 0.9rem; }",
    "  .ls-cp__analysis { border-radius: 12px; padding: 0.9rem; }",
    "  .ls-cp__table { font-size: 0.85rem; }",
    "  .ls-cp__table th, .ls-cp__table td { padding: 0.5rem 0.5rem; }",
    "  .ls-cp__quality-promise { padding: 0.95rem; }",
    "  .ls-cp__methodology { padding: 0.85rem 1rem; }",
    "  .ls-cp__notice { padding: 0.85rem 1rem; }",
    "  .ls-cp__download, .ls-cp__retry { justify-content: center; width: 100%; }",
    "}",
    "@media (max-width: 749px) {",
    "  .ls-qm-choice-heading { margin: 14px 0 8px; }",
    "  .ls-qm-choice-heading h2 { font-size: 1rem; }",
    "  .ls-qm-choice-heading p { display: none; }",
    "  .ls-qm-variant-grid { display: grid; grid-template-columns: 1fr; gap: 7px; overflow: visible; padding: 0; scroll-snap-type: none; }",
    "  .ls-qm-variant-card, .ls-qm-variant-card--heulage { flex-basis: auto; display: block; position: relative; border-radius: 11px; padding: 10px 12px 10px 42px; }",
    "  .ls-qm-variant-card:hover { box-shadow: none; transform: none; }",
    "  .ls-qm-variant-card__media { display: none; }",
    "  .ls-qm-variant-card::before { content: ''; position: absolute; left: 13px; top: 50%; width: 17px; height: 17px; transform: translateY(-50%); border: 2px solid #a9bcc5; border-radius: 50%; background: #fff; }",
    "  .ls-qm-variant-card.is-selected::before { border-color: #00a5df; background: #00a5df; box-shadow: inset 0 0 0 3px #fff; }",
    "  .ls-qm-variant-card__content, .ls-qm-variant-card--heulage .ls-qm-variant-card__content { display: grid; grid-template-columns: minmax(0, 1fr) auto; grid-template-areas: 'stage price' 'count price' 'units units'; align-items: center; gap: 0 10px; min-height: 0; padding: 0; }",
    "  .ls-qm-variant-card__stage { grid-area: stage; font-size: 0.7rem; }",
    "  .ls-qm-variant-card__content strong { grid-area: count; font-size: 0.88rem; }",
    "  .ls-qm-variant-card__price { grid-area: price; align-self: center; margin-top: 0; font-size: 1.08rem; text-align: right; }",
    "  .ls-qm-variant-card__unit-prices { grid-area: units; display: flex; flex-wrap: wrap; gap: 0 8px; margin-top: 3px; font-size: 0.68rem; }",
    "  .ls-qm-variant-card__state { position: static; display: inline-block; margin-top: 5px; padding: 2px 6px; font-size: 0.55rem; }",
    "  .ls-qm-variant-card.is-selected .ls-qm-variant-card__state { display: none; }",
    "  .ls-qm-variant-card--heulage.is-unavailable:not(.is-selected) .ls-qm-variant-card__state { position: static; top: auto; right: auto; bottom: auto; }",
    "  .ls-qm-variant-card.is-unavailable:not(.is-selected) { opacity: 0.55; }",
    "}"
  ].join("\n");

  function injectStyle() {
    if (document.getElementById("ls-cp-mobile-css")) return;
    var style = document.createElement("style");
    style.id = "ls-cp-mobile-css";
    style.textContent = CSS;
    (document.body || document.head).appendChild(style);
  }

  var mq = window.matchMedia ? window.matchMedia("(max-width: 749px)") : null;
  var storyBuilt = false;

  function collapse(host, items, summaryText, detailsClass, summaryClass) {
    if (!items.length) return;
    var details = document.createElement("details");
    details.className = detailsClass;
    var summary = document.createElement("summary");
    summary.className = summaryClass;
    summary.textContent = summaryText;
    details.appendChild(summary);
    for (var i = 0; i < items.length; i++) details.appendChild(items[i]);
    host.appendChild(details);
  }

  /* Produkttext (Teil vor dem Faktenblock-Trenner) oben in den Kaufbereich setzen –
     aktuell DEAKTIVIERT (Text steht im Chargenpass); Funktion bleibt fuer Rueckbau. */
  function buildProductStory() {
    if (storyBuilt || document.querySelector(".ls-qm-product-story")) { storyBuilt = true; return; }
    var source = document.querySelector("[data-ls-product-description]");
    var summaryBox = document.querySelector(".ls-qm-charge-summary");
    if (!source || !summaryBox || !summaryBox.parentNode) return;

    var story = document.createElement("div");
    story.className = "ls-cp__section ls-cp__section--wide ls-qm-product-story";
    var points = document.createElement("ul");
    points.className = "ls-cp__selling-points";
    var morePoints = document.createElement("ul");
    morePoints.className = "ls-cp__selling-points";
    var more = document.createElement("details");
    more.className = "ls-cp__body-more";
    var moreSummary = document.createElement("summary");
    moreSummary.className = "ls-cp__body-more-summary";
    moreSummary.textContent = "Weiterlesen";
    more.appendChild(moreSummary);

    var count = 0;
    var checkCount = 0;
    var bodyCount = 0;
    var firstPara = null;
    var moreParas = [];
    for (var node = source.firstElementChild; node; node = node.nextElementSibling) {
      if (node.tagName === "HR" || node.querySelector && node.querySelector("hr")) break;
      var text = (node.textContent || "").replace(/\s+/g, " ").trim();
      if (!text) continue;
      var isCheck = text.charAt(0) === "✓";
      if (count === 0) {
        var lead = node.cloneNode(true);
        lead.className = "ls-cp__lead";
        story.appendChild(lead);
      } else if (isCheck) {
        var item = document.createElement("li");
        item.className = "ls-cp__selling-point";
        item.textContent = text.replace(/^✓\s*/, "");
        if (checkCount < 3) points.appendChild(item);
        else morePoints.appendChild(item);
        checkCount++;
      } else {
        var para = node.cloneNode(true);
        para.className = "ls-cp__body";
        if (bodyCount === 0) firstPara = para;
        else moreParas.push(para);
        bodyCount++;
      }
      count++;
    }
    if (!count) return;
    if (points.childNodes.length) story.appendChild(points);
    if (firstPara) story.appendChild(firstPara);
    if (morePoints.childNodes.length) more.appendChild(morePoints);
    for (var p = 0; p < moreParas.length; p++) more.appendChild(moreParas[p]);
    if (morePoints.childNodes.length || moreParas.length) story.appendChild(more);
    summaryBox.parentNode.insertBefore(story, summaryBox.nextSibling);
    storyBuilt = true;
  }

  /* Chargenpass-Titel nach Produktart: "dieses Heu" / "diese Heulage" / "dieses Stroh" */
  function suitabilityLabel() {
    var section = document.querySelector("[data-ls-chargenpass]");
    var type = ((section && section.getAttribute("data-product-type")) || "").toLowerCase();
    if (type === "heu") return "dieses Heu";
    if (type === "heulage") return "diese Heulage";
    if (type.indexOf("stroh") !== -1) return "dieses Stroh";
    return "";
  }

  function retitleSuitability(content) {
    if (!content) return;
    var label = suitabilityLabel();
    if (!label) return;
    var nodes = content.querySelectorAll(".ls-cp__section-title, h2, h3");
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.getAttribute("data-ls-retitled")) continue;
      if ((node.textContent || "").trim() === "Für welches Pferd passt diese Charge?") {
        node.textContent = "Für welches Pferd passt " + label + "?";
        node.setAttribute("data-ls-retitled", "1");
      }
    }
  }

  /* Text-Wiederholung im Chargenpass ausblenden – nur relevant, wenn die Story
     oben aktiv ist; aktuell ungenutzt. */
  function hideDescriptionIn(content) {
    if (!storyBuilt || !content) return;
    var sections = content.querySelectorAll(".ls-cp__section--wide");
    for (var s = 0; s < sections.length; s++) {
      var sec = sections[s];
      if (sec.querySelector(".ls-cp__lead")) sec.hidden = true;
    }
  }

  function enhance(content) {
    if (!mq || !mq.matches || !content) return;

    /* 1) Chargen-Beschreibung im Pass (nur falls sichtbar geblieben): einklappen */
    var sections = content.querySelectorAll(".ls-cp__section--wide");
    for (var s = 0; s < sections.length; s++) {
      var sec = sections[s];
      if (sec.hidden) continue;
      if (sec.getAttribute("data-ls-mobile-done")) continue;
      if (!sec.querySelector(".ls-cp__lead")) continue;
      var bodies = [];
      for (var b = 0; b < sec.children.length; b++) {
        var child = sec.children[b];
        if (child.classList && child.classList.contains("ls-cp__body")) bodies.push(child);
      }
      if (bodies.length < 2) continue;
      sec.setAttribute("data-ls-mobile-done", "1");
      collapse(sec, bodies.slice(1), "Weiterlesen", "ls-cp__body-more", "ls-cp__body-more-summary");
    }

    /* 2) Eignungskarten: Begruendung und Hinweis einklappen */
    var cards = content.querySelectorAll(".ls-cp__fit-card");
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      if (card.getAttribute("data-ls-mobile-done")) continue;
      card.setAttribute("data-ls-mobile-done", "1");
      var parts = [];
      var reason = card.querySelector(".ls-cp__fit-reason");
      var note = card.querySelector(".ls-cp__fit-note");
      if (reason) parts.push(reason);
      if (note) parts.push(note);
      collapse(card, parts, "Begründung ansehen", "ls-cp__fit-details", "ls-cp__fit-details-summary");
    }
  }

  /* Grundpreis in der Auswahl-Box ergaenzen (alle Geraete, PAngV) */
  function enhanceQuantitySummaries() {
    var money = null;
    try { money = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }); } catch (e) { return; }
    var summaries = document.querySelectorAll("[data-ls-qm-quantity-summary]");
    for (var i = 0; i < summaries.length; i++) {
      var box = summaries[i];
      if (box.getAttribute("data-ls-baseprice-done")) continue;
      var cents = Number(box.getAttribute("data-unit-price-cents") || 0);
      var balls = Number(box.getAttribute("data-ball-count") || 0);
      var kg = Number(box.getAttribute("data-weight-kg") || 0);
      if (!cents) continue;
      var parts = [];
      if (balls > 0) parts.push(money.format(cents / 100 / balls) + " je Ballen");
      if (kg > 0) parts.push(money.format(cents / 100 / kg) + " je kg");
      if (!parts.length) continue;
      box.setAttribute("data-ls-baseprice-done", "1");
      var line = document.createElement("p");
      line.className = "ls-qm-quantity-summary__baseprice";
      line.textContent = "Grundpreis: " + parts.join(" · ");
      var legal = box.querySelector(".ls-qm-quantity-summary__legal");
      if (legal) box.insertBefore(line, legal);
      else box.appendChild(line);
    }
  }

  /* Lieferzeit-Widget (delm App-Block) in die Auswahl-Box verschieben */
  function moveDeliveryWidget() {
    var box = document.querySelector("[data-ls-qm-quantity-summary]");
    if (!box) return false;
    if (box.querySelector(".ls-qm-delivery-note")) return true;
    var widget = document.querySelector('[id^="shopify-block-"][id*="delm"]');
    if (!widget) {
      var inner = document.querySelector('[class*="delm"], [id*="delm"]');
      if (inner && !box.contains(inner)) {
        widget = inner.closest('[id^="shopify-block-"]') || inner;
      }
    }
    if (!widget || box.contains(widget) || widget.contains(box)) return false;
    if (!(widget.textContent || "").trim()) return false;
    widget.classList.add("ls-qm-delivery-note");
    box.appendChild(widget);
    return true;
  }

  var deliveryTries = 0;
  function tryMoveDelivery() {
    if (moveDeliveryWidget()) return;
    deliveryTries++;
    if (deliveryTries < 30) window.setTimeout(tryMoveDelivery, 250);
  }

  function watch() {
    injectStyle();
    enhanceQuantitySummaries();
    tryMoveDelivery();
    var containers = document.querySelectorAll("[data-ls-cp-content]");
    for (var i = 0; i < containers.length; i++) {
      (function (content) {
        retitleSuitability(content);
        enhance(content);
        if (window.MutationObserver) {
          new MutationObserver(function () {
            retitleSuitability(content);
            enhance(content);
          }).observe(content, { childList: true });
        }
      })(containers[i]);
    }
    if (mq && mq.addEventListener) {
      mq.addEventListener("change", function (event) {
        if (!event.matches) return;
        for (var i = 0; i < containers.length; i++) enhance(containers[i]);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch);
  } else {
    watch();
  }
})();
